export default __webpack_public_path__ + "static/media/pimpinellifolium.7cbdb2f3.jpg";